export const makeUrlRelative = (url: URL) => url.href.replace(url.origin, '');

export const processHref = ({ href, makeRelative }: { href: string; makeRelative: boolean; }) => {
  if (!URL.canParse(href)) return href;

  const url = new URL(href);

  if (url.origin === 'https://academy.klaviyo.com') {
    // academy is not yet localized so we hardcode en-us as locale
    const locale = 'en-us';

    if (url.pathname.includes('/path')) {
      // /path/<collection-slug> -> /<locale>/collections/<collection-slug>
      url.pathname = `/${locale}/collections${url.pathname.replace('/path', '')}`;

      // if the pathname only has one segment, we have a course
      // length is 2 because it yields ['', '<course-slug>']
    } else if (url.pathname.split('/').length === 2) {
      // /course-slug -> /<locale>/courses/<course-slug>
      url.pathname = `/${locale}/courses${url.pathname}`;
    }
  }

  if (makeRelative) {
    return makeUrlRelative(url);
  }

  return url.href;
};
